import { render, staticRenderFns } from "./reset-row.vue?vue&type=template&id=10f270d6&scoped=true"
import script from "./reset-row.vue?vue&type=script&lang=js"
export * from "./reset-row.vue?vue&type=script&lang=js"
import style0 from "./reset-row.vue?vue&type=style&index=0&id=10f270d6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f270d6",
  null
  
)

export default component.exports